import tw from 'twin.macro'

export const ListContainer = tw.div`py-3`
export const ListItem = tw.div`bg-gray-200 rounded-lg py-4 px-5 grid grid-cols-3 gap-4 my-2`
export const ListItemTransparent = tw.div`grid grid-cols-3 gap-2`

export const LeftColumn = tw.div`col-span-2 py-2`
export const RightColumn = tw.div`text-right`